import { HTMLAttributes } from 'react';

interface ContentAddBodyProps extends HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode,
}

function ContentAddBody({ ...props }: ContentAddBodyProps) {
    const { children } = props;
    return (
        <div {...props} className="content-add__body">
            {children}
        </div>
    );
}

export default ContentAddBody;
